import {useQuery} from "@tanstack/react-query";
import {useAxios} from "../../hooks/axios/useAxios";
import {assignedCoursesWithProgramsUrl} from "../../constants/api/soft-user/endpoints";

interface GetCoursesParams {
  show_all?: boolean,
  search_term?: string,
  current_page?: number,
  portfolio_id?: string
}

export const useQueryUserAssignedCourses = (params: GetCoursesParams) => {
  const axios = useAxios();

  const handleRequest = () => {
    return axios.get(assignedCoursesWithProgramsUrl, {
      params: params
    })
      .then(response => response?.data?.data ?? response);
  }

  return useQuery({
    queryKey: ['assigned-courses-by-user', params],
    queryFn: handleRequest
  })

}
